/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiGetContentByKeyQueryResponse, ContentAiGetContentByKeyPathParams, ContentAiGetContentByKey401, ContentAiGetContentByKey403 } from "../models/ContentAiGetContentByKey";

export function getContentAiGetContentByKeyUrl(key: ContentAiGetContentByKeyPathParams["key"]) {
  const res = { method: 'GET', url: `/content-ai/v1/contents/key/${key}` as const }
  return res
}

/**
 * @description Keys are used to identify fragments based on an external ID (e.g.: `FRAGMENT:123456`)
 * @summary Get content by key
 * {@link /content-ai/v1/contents/key/:key}
 */
export async function contentAiGetContentByKey(key: ContentAiGetContentByKeyPathParams["key"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ContentAiGetContentByKeyQueryResponse, ResponseErrorConfig<ContentAiGetContentByKey401 | ContentAiGetContentByKey403>, unknown>({ method : "GET", url : getContentAiGetContentByKeyUrl(key).url.toString(), ... requestConfig })
  return res.data
}